import { Box, Grid, TextField, Typography } from "@mui/material";
import CommentIcon from "@mui/icons-material/Comment";
import React from "react";
import { sizes } from "./defineUtils";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "./defineSlice";

export default function Comments() {
   const dispatch = useDispatch();
   const State = useSelector((store) => store.define);
   const { comments } = State;

   function updateComment(event) {
      const comment = event.target.value;
      dispatch(setState("comments", comment));
   }

   return (
      <Grid container>
         <Grid item xs={12}>
            {" "}
            <Box sx={{ mt: -1, display: "flex", flexDirection: "row" }}>
               {/* <Typography className="compHeading"
                  sx={{ ml: 1, fontWeight: "bold", color: "blue.main", width: "82%" }}
               >
                   <CommentIcon sx={{ color: "blue.main", transform: "translate(0px, 6px)", mr: 1,}} />
                  Comment
               </Typography> */}
            </Box>{" "}
            <TextField
               className={"fullHeight fullWidth"}
               variant="outlined"
               overflow="scroll"
               multiline
               size="large"
               maxRows={6}
               sx={{ mt: 2}}
               style={{ overflowY: "auto" }}
               value={comments}
               onChange={updateComment}
            />
         </Grid>
         
         {/* <Grid item xs={5}>
            <Typography variant="subtitle1">Quota Allocation to customers could be saved/submitted by: </Typography>
            <ol>
               <li>Entering/Editing Quota Copy value, clicking on “Allocate” button, adjusting Quota values (Safety Margin/Adjustment fields/Allowed weekly depletion values) and then clicking on “Save Quota/Submit Quota” button</li>
               <li>Downloading an excel file of customer breakdown table, editing “Initial Quota, Safety Margin, Adjustment, Allowed weekly depletion quota values. Uploading and processing excel file back to SiMS and then clicking on “Save Quota/Submit Quota” button.</li>
            </ol>
         </Grid> */}
      </Grid>
   );
}
